import { ErrorBoundaryWithLogging } from "app/pages/sales-intelligence/common-components/ErrorBoundaryWithLogging";
import type { MarkdownMessageProps } from "app/pages/sales-intelligence/modules/ai-agent/components/MarkdownMessage/types";
import { MeetingAgentMessageError } from "app/pages/sales-intelligence/modules/ai-agent/components/MeetingAgentMessageError/MeetingAgentMessageError";

import { MeetingAgentMessage } from "./MeetingAgentMessage";

const ErrorFallback = ({ resetErrorBoundary }: { resetErrorBoundary: () => void }) => (
    <MeetingAgentMessageError onRetry={resetErrorBoundary} />
);

export const MeetingAgentMessageWithErrorBoundary = (props: MarkdownMessageProps) => {
    return (
        <ErrorBoundaryWithLogging FallbackComponent={ErrorFallback}>
            <MeetingAgentMessage {...props} />
        </ErrorBoundaryWithLogging>
    );
};
